import React from 'react';
import { Box } from '@mui/material';

export default function HeroBg({ caseData }) {
  if (!caseData?.heroVideoUrl && !caseData?.heroImageUrl) return null;
  return (
    <Box sx={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none', overflow: 'hidden' }}>
      {/* Solid dark base so the semi-transparent media always shows on dark, not white */}
      <Box sx={{ position: 'absolute', inset: 0, bgcolor: '#0d1117' }} />
      {caseData.heroVideoUrl ? (
        <Box component="video" src={caseData.heroVideoUrl}
          autoPlay muted loop playsInline
          sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.35 }} />
      ) : (
        <Box component="img" src={caseData.heroImageUrl}
          sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.25 }} />
      )}
      {/* Dark overlay to ensure readability */}
      <Box sx={{ position: 'absolute', inset: 0, bgcolor: 'rgba(13,17,23,0.55)' }} />
    </Box>
  );
}
